import React, {Component} from 'react';
import './planSubscriptionCard.scss';

class PlanSubscriptionCard extends Component {
  constructor(props){
    super(props);
  }

  renderBtn(planCodename, saasVersion){
    const {onPlanChanged, currentVersionName} = this.props;

    if(currentVersionName === planCodename){
      return <button className='btn btn-primary' disabled>{__('Current Plan', 'settings')}</button>
    }else {
      return <button className='btn btn-primary' onClick={()=>onPlanChanged(planCodename, saasVersion)}>{__('Choose Plan', 'settings')}</button>
    }
  }
  render(){
    const {billCycle, data} = this.props;
    const {
      version, 
      monthlyPrice, 
      yearlyPrice, 
      studentAmount, 
      teacherAmount, 
      schoolAmount, 
      monthlyPlanCodename,
      yearlyPlanCodename,
      additionalMsg,
      saasVersionMonthly,
      saasVersionYearly
    } = data;
    let imagePath;
    if(version==='Basic'){
      imagePath= require('../../data/images/school1.png');
    }else if(version==='Professional'){
      imagePath= require('../../data/images/school2.png');
    }else{
      imagePath= require('../../data/images/school3.png');
    }
    const planCodename = billCycle ==='monthly'? monthlyPlanCodename: yearlyPlanCodename;
    const saasVersion = billCycle ==='monthly'? saasVersionMonthly: saasVersionYearly;
    return (
      <div className='plan-wrapper col-md-4'>
        <div className='icon-wrapper' style={{backgroundImage: `url(${imagePath})`}}></div>
        <div className="plan-title">{__(version, 'settings')}</div>
        <div className="plan-price">${billCycle==='monthly'? monthlyPrice: yearlyPrice}<span className='dollar'>{__('USD', 'settings')}</span></div>
        <div className="plan-cycle">{billCycle==='monthly'? __('per month, billed monthly', 'settings'): __('per month, billed yearly', 'settings')}</div>
        <div className="plan-detail">
          <div>{studentAmount==='unlimited'? __('Unlimited', 'settings'): studentAmount} {__('Registered Students', 'settings')}</div>
          <div>{teacherAmount==='unlimited'? __('Unlimited', 'settings'): teacherAmount} {__('Registered Teachers', 'settings')}</div>
          <div>{schoolAmount} {__('Campus', 'settings')}</div>
          {
            additionalMsg && 
            <div className='additional-msg'>{additionalMsg}</div>
          }
        </div>
        {this.renderBtn(planCodename, saasVersion)}
      </div>
    );
  }
}
export default PlanSubscriptionCard;


// WEBPACK FOOTER //
// ./src/shared/planSubscriptionCard/index.js